"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var pay_api_1 = require("@l2p/pay-api");
var public_api_1 = require("@l2p/public-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var Lockr = __importStar(require("lockr"));
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var Tabs_1 = __importDefault(require("../Tabs"));
var all_1 = require("../icons/all");
var bank_transfer_1 = require("../icons/bank-transfer");
var cards_1 = require("../icons/cards");
var crypto_1 = require("../icons/crypto");
var payment_systems_1 = require("../icons/payment-systems");
var vouchers_1 = require("../icons/vouchers");
var DepositFields_1 = require("./DepositFields");
var useDepositReturnLinks_1 = __importDefault(require("./DepositFields/useDepositReturnLinks"));
var useInitialValues_1 = require("./DepositFields/useInitialValues");
var useValidationSchema_1 = require("./DepositFields/useValidationSchema");
// import GeoLocation from './GeoLocation'
var play_api_1 = require("@l2p/play-api");
var date_fns_1 = require("date-fns");
var GamblingLimits_1 = require("../../GamblingLimits");
var Method_1 = __importDefault(require("./Method"));
var ProcessingTotalInfo_1 = __importDefault(require("./ProcessingTotalInfo"));
var Search_1 = __importDefault(require("./Search"));
var SubHeader_1 = __importDefault(require("./SubHeader"));
var TopupButton_1 = __importDefault(require("./TopupButton"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useMethods_1 = require("./useMethods");
var usePendingContentForNewTab_1 = require("./usePendingContentForNewTab");
var normalizeDepositValues_1 = require("./normalizeDepositValues");
var DepositMethodIssue_1 = require("./DepositMethodIssue");
var FAILED_DEPOSIT_METHODS = [
    'ph_sc',
    'ph_pr',
    'vp_pr',
    'vp_sc',
    'ix_cards_onramp',
    'lbs_coupon_eur',
];
var ALREADY_CLOSED_DEPOSIT = 'alreadyClosedDeposit';
var accountTypes = [
    { value: 'IBAN', label: 'IBAN' },
    { value: 'Account number', label: 'Account number' },
];
var Deposit = function (_a) {
    var _b, _c;
    var paymentSettings = _a.paymentSettings, isModal = _a.isModal, _d = _a.isFailed, isFailed = _d === void 0 ? false : _d, _e = _a.methodsSlugForFailedDeposit, methodsSlugForFailedDeposit = _e === void 0 ? FAILED_DEPOSIT_METHODS : _e, defaultAmount = _a.defaultAmount, defaultBonusId = _a.defaultBonusId;
    var checkDepositLimitReached = (0, GamblingLimits_1.useCheckDepositLimitReached)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var pendingContentForNewTab = (0, usePendingContentForNewTab_1.usePendingContentForNewTab)();
    var userDataError = (0, swr_hooks_1.useUser)().error;
    var config = (0, swr_hooks_1.useConfig)();
    var _f = (0, react_1.useState)(false), isChangeDepositMethodIssue = _f[0], changeDepositMethodIssue = _f[1];
    var isDepositMethodIssuePopupEnabled = (_b = config === null || config === void 0 ? void 0 : config.depositMethodIssuePopup) === null || _b === void 0 ? void 0 : _b.enabled;
    var isPhoneVerificationEnabled = (0, swr_hooks_1.useGetIsPhoneVerificationEnabled)().data;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var openSignIn = (0, apps_shared_1.useOpenSignIn)();
    var balanceData = (0, swr_hooks_1.useBalance)().data;
    var currentCurrency = balanceData === null || balanceData === void 0 ? void 0 : balanceData.currency;
    var searchParams = (0, navigation_1.useSearchParams)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _g = (0, react_1.useState)({
        amount: defaultAmount,
        bonusId: defaultBonusId,
        promoId: '',
    }), defaultsFields = _g[0], setDefaultsFields = _g[1];
    var _h = (0, react_1.useState)(false), isOpenWelcomeBonus = _h[0], setIsOpenWelcomeBonus = _h[1];
    var globalConfig = (0, swr_hooks_1.useConfig)();
    var _j = (0, react_1.useState)(''), IFrameUrl = _j[0], setIFrameUrl = _j[1];
    var _k = (0, react_1.useState)('default'), step = _k[0], setStep = _k[1];
    var _l = (0, react_1.useState)(false), mounted = _l[0], setMounted = _l[1];
    var _m = (0, react_1.useState)(null), selectedMethod = _m[0], setSelectedMethod = _m[1];
    var _o = (0, react_1.useState)('all'), filter = _o[0], setFilter = _o[1];
    var _p = (0, react_1.useState)(undefined), promocode = _p[0], setPromocode = _p[1];
    var _q = (0, react_1.useState)(''), search = _q[0], setSearch = _q[1];
    var onChangeSearch = function (e) { return setSearch(e.target.value); };
    var _r = (0, swr_hooks_1.useBonusesByPromocode)(public_api_1.BonusType.Deposit, promocode), bonusesData = _r.data, isLoadingBonuses = _r.isLoading, isValidatingBonuses = _r.isValidating;
    var METHODS_FILTERS = (0, react_1.useMemo)(function () { return [
        { label: t('all'), Icon: all_1.AllIcon, key: 'all' },
        { label: t('cards'), Icon: cards_1.CardsIcon, stroke: true, key: 'cards' },
        {
            label: t('bankTransfers'),
            Icon: bank_transfer_1.BankTransferIcon,
            stroke: true,
            key: 'bank-transfer',
        },
        {
            label: t('paymentSystems'),
            Icon: payment_systems_1.PaymentSystemsIcon,
            stroke: true,
            key: 'payment-systems',
        },
        { label: t('crypto'), Icon: crypto_1.CryptoIcon, stroke: true, key: 'crypto' },
        {
            label: t('vouchers'),
            Icon: vouchers_1.VouchersIcon,
            stroke: true,
            key: 'vouchers',
        },
    ]; }, [t]);
    var profileCountry = (0, swr_hooks_1.useProfileCountry)();
    var _s = (0, swr_hooks_1.usePayInMethodsProfile)(), methodsData = _s.data, isLoading = _s.isLoading;
    var updateProfile = (0, swr_hooks_1.useUpdateProfileData)({}).updateProfile;
    var filteredMethods = (0, react_1.useMemo)(function () {
        if (isFailed)
            return (methodsData === null || methodsData === void 0 ? void 0 : methodsData.payIn.getMethods.edges) || [];
        return ((methodsData === null || methodsData === void 0 ? void 0 : methodsData.payIn.getMethods.edges) || []).filter(function (method) { return !methodsSlugForFailedDeposit.includes(method.slug || ''); });
    }, [
        isFailed,
        methodsData === null || methodsData === void 0 ? void 0 : methodsData.payIn.getMethods.edges,
        methodsSlugForFailedDeposit,
    ]);
    var methods = (0, useMethods_1.useMethods)({
        paymentSettings: paymentSettings,
        methods: filteredMethods,
        country: profileCountry,
    });
    var oneDepositMethodOnly = (0, react_1.useMemo)(function () {
        if (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.oneDepositMethodOnly) {
            var oneDepositMethod = methods.find(function (m) { return m.slug === (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.oneDepositMethodOnly); });
            if (oneDepositMethod) {
                return true;
            }
            return false;
        }
        return false;
    }, [globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.oneDepositMethodOnly, methods === null || methods === void 0 ? void 0 : methods.length]);
    var recentMethodsByCount = methods.filter(function (m) { var _a; return Boolean((_a = m === null || m === void 0 ? void 0 : m.statistic) === null || _a === void 0 ? void 0 : _a.paymentCount); });
    var featuredRecentMethods = methods.filter(function (m) { return m.featured; });
    var filteredRecentMethods = recentMethodsByCount.filter(function (method) { return !methodsSlugForFailedDeposit.includes(method.slug || ''); });
    var recentMethods = filteredRecentMethods.length && featuredRecentMethods.length
        ? __spreadArray(__spreadArray([], filteredRecentMethods, true), featuredRecentMethods, true) : filteredRecentMethods;
    (0, react_1.useEffect)(function () {
        if (isFailed) {
            var methodsForFailedDeposit = ((methodsData === null || methodsData === void 0 ? void 0 : methodsData.payIn.getMethods.edges) || []).filter(function (m) { return methodsSlugForFailedDeposit.includes(m.slug || ''); });
            if (methodsForFailedDeposit[0]) {
                setMethodSelected(methodsForFailedDeposit[0]);
                setStep('topup');
            }
        }
    }, [isFailed, filteredMethods]);
    (0, react_1.useEffect)(function () {
        setFilter('all');
    }, [search]);
    // set recent methods if available
    (0, react_1.useEffect)(function () {
        if (recentMethods.length &&
            !(globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.oneDepositMethodOnly) &&
            step === 'default') {
            if (!isFailed) {
                setStep('recent');
                setSelectedMethod(recentMethods[0]);
            }
        }
    }, [recentMethods.length, globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.oneDepositMethodOnly, isFailed]);
    // set one deposit method if only one available
    (0, react_1.useEffect)(function () {
        if (methods.find(function (m) { return m.slug === (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.oneDepositMethodOnly); })) {
            var method = methods.find(function (m) { return m.slug === (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.oneDepositMethodOnly); });
            if (method) {
                setSelectedMethod(method);
                setStep('topup');
            }
        }
    }, [globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.oneDepositMethodOnly, methods]);
    (0, react_1.useEffect)(function () {
        if (searchParams) {
            var methodId_1 = searchParams.get('methodId');
            if (methodId_1) {
                var method = filteredMethods.find(function (m) { return m.id === methodId_1; });
                if (method) {
                    setStep('topup');
                    setSelectedMethod(method);
                }
            }
            var promocodeParam = searchParams.get('promocode');
            if (promocodeParam) {
                setPromocode(promocodeParam);
            }
        }
    }, [searchParams, filteredMethods]);
    (0, react_1.useEffect)(function () {
        var promocodeParam = searchParams.get('promocode');
        if ((bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.promoId) && promocodeParam) {
            var bonus = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.bonuses.find(function (b) { return b.type === public_api_1.BonusType.Promo; });
            setDefaultsFields(__assign(__assign({}, defaultsFields), { bonusId: (bonus === null || bonus === void 0 ? void 0 : bonus.id) || '', promoId: bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.promoId }));
        }
    }, [(_c = bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.bonuses) === null || _c === void 0 ? void 0 : _c.length, searchParams]);
    var methodsWithSearch = methods === null || methods === void 0 ? void 0 : methods.filter(function (m) {
        var _a;
        if (filter === 'all') {
            return m;
        }
        else {
            return ((_a = m.category) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === filter.toLowerCase();
        }
    }).filter(function (m) { var _a; return (_a = m === null || m === void 0 ? void 0 : m.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search.toLowerCase()); });
    var filterIndexMap = (0, react_1.useMemo)(function () {
        var map = {};
        METHODS_FILTERS.forEach(function (filter, index) {
            map[filter.key] = index;
        });
        return map;
    }, [METHODS_FILTERS]);
    var categories = Array.from(new Set(methods === null || methods === void 0 ? void 0 : methods.map(function (m) { return m.category; }).filter(Boolean))).sort(function (a, b) {
        var indexA = filterIndexMap[String(a)] !== undefined
            ? filterIndexMap[String(a)]
            : Infinity;
        var indexB = filterIndexMap[String(b)] !== undefined
            ? filterIndexMap[String(b)]
            : Infinity;
        return indexA - indexB;
    });
    var currencySettings = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var minConstraint = (_a = selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.constraints) === null || _a === void 0 ? void 0 : _a.find(function (c) { return c.type === pay_api_1.PayInConstraintType.MinTransaction; });
        var maxConstraint = (_b = selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.constraints) === null || _b === void 0 ? void 0 : _b.find(function (c) { return c.type === pay_api_1.PayInConstraintType.MaxTransaction; });
        var min = ((_d = (_c = minConstraint === null || minConstraint === void 0 ? void 0 : minConstraint.minTransaction) === null || _c === void 0 ? void 0 : _c.find(function (t) { return t.currency === currentCurrency; })) === null || _d === void 0 ? void 0 : _d.amount) || '0';
        var max = ((_f = (_e = maxConstraint === null || maxConstraint === void 0 ? void 0 : maxConstraint.maxTransaction) === null || _e === void 0 ? void 0 : _e.find(function (t) { return t.currency === currentCurrency; })) === null || _f === void 0 ? void 0 : _f.amount) || '10000';
        var fixedTransactionData = (_g = selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.constraints) === null || _g === void 0 ? void 0 : _g.find(function (c) { return c.type === pay_api_1.PayInConstraintType.FixedTransaction; });
        var fixedTransaction = (_h = fixedTransactionData === null || fixedTransactionData === void 0 ? void 0 : fixedTransactionData.fixedTransaction) === null || _h === void 0 ? void 0 : _h.find(function (t) { return t.currency === currentCurrency; });
        return {
            min: "".concat(min),
            max: "".concat(max),
            fixedTransaction: fixedTransaction,
        };
    }, [selectedMethod, currentCurrency]);
    var depositCallbackUrls = (0, useDepositReturnLinks_1.default)();
    // const [vouchstarOpen, setVouchstarOpen] = useState(false)
    var newTabRef = (0, react_1.useRef)(null);
    var reportCommonError = (0, swr_hooks_1.useReportCommonError)().reportCommonError;
    var handleClickSubmitBtn = function () {
        // newTabRef.current = window.open('about:blank', '_blank')
        // if (newTabRef.current) {
        //   newTabRef.current.document.write(pendingContentForNewTab)
        //   newTabRef.current.document.close()
        // }
    };
    var _t = (0, swr_hooks_1.useMakePayIn)({
        successAction: function (data) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            changeDepositMethodIssue(false);
            if (typeof window !== 'undefined')
                Lockr.set(ALREADY_CLOSED_DEPOSIT, false);
            // if (selectedMethod?.metadata?.['vs_shop']) return setVouchstarOpen(true)
            if (((_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.payIn) === null || _b === void 0 ? void 0 : _b.create) === null || _c === void 0 ? void 0 : _c.payment) === null || _d === void 0 ? void 0 : _d.redirectType) !== 'Frame') {
                if ((_h = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 : _e.payIn) === null || _f === void 0 ? void 0 : _f.create) === null || _g === void 0 ? void 0 : _g.payment) === null || _h === void 0 ? void 0 : _h.url) {
                    // if (newTabRef.current) {
                    //   newTabRef.current.document.open()
                    //   newTabRef.current.document.write(
                    //     getRedirectFormForNewTab(data?.data?.payIn?.create?.payment?.url),
                    //   )
                    //   newTabRef.current.document.close()
                    // }
                    // newTabRef.current.location = data?.data.payIn.create.payment.url
                    // else window.location.href = data?.data.payIn.create.payment.url
                    window.location.href = data === null || data === void 0 ? void 0 : data.data.payIn.create.payment.url;
                }
            }
            else {
                setStep('iframe');
                setIFrameUrl(data === null || data === void 0 ? void 0 : data.data.payIn.create.payment.url);
            }
        },
        errorAction: function (error) {
            var _a;
            changeDepositMethodIssue(true);
            if (newTabRef.current)
                newTabRef.current.close();
            try {
                reportCommonError({
                    errorMessage: "SELECTED METHOD: ".concat(selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.slug, " | ERROR: ").concat(error === null || error === void 0 ? void 0 : error.message),
                    errorName: error === null || error === void 0 ? void 0 : error.name,
                    reqUrl: typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href : '',
                });
            }
            catch (err) { }
        },
    }), data = _t.data, makePayIn = _t.makePayIn, isSubmitting = _t.isSubmitting;
    var lotteriesData = (0, swr_hooks_1.useLotteries)().data;
    var activeLottery = (0, react_1.useMemo)(function () {
        if (!lotteriesData)
            return null;
        return lotteriesData === null || lotteriesData === void 0 ? void 0 : lotteriesData.find(function (lottery) { return lottery.status === play_api_1.LotteryStatusEnum.Active; });
    }, [lotteriesData]);
    var initialValues = (0, useInitialValues_1.useInitialValues)({
        fields: selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.requiredFields,
        min: (currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.min) || '0',
        accountTypes: accountTypes,
        defaultAmount: defaultsFields.amount,
        defaultBonusId: defaultsFields.bonusId,
        defaultPromoId: defaultsFields.promoId,
    });
    var validationSchema = (0, useValidationSchema_1.useValidateSchema)({
        fields: (selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.requiredFields) || [],
        min: (currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.min) || '0',
        max: (currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.max) || '10000',
        currency: currentCurrency,
    });
    var onSubmitHandler = (0, react_1.useCallback)(function (_a) {
        var _b, _c;
        var amount = _a.amount, values = __rest(_a, ["amount"]);
        var depositLimit = checkDepositLimitReached();
        if (depositLimit === null || depositLimit === void 0 ? void 0 : depositLimit.isReached)
            return depositLimit === null || depositLimit === void 0 ? void 0 : depositLimit.redirect();
        var depositDateOfBirth = (values === null || values === void 0 ? void 0 : values.birthdayDate)
            ? (values === null || values === void 0 ? void 0 : values.birthdayDate) instanceof Date
                ? (0, date_fns_1.format)(new Date(values === null || values === void 0 ? void 0 : values.birthdayDate), 'yyyy-MM-dd')
                : (values === null || values === void 0 ? void 0 : values.birthdayDate) || (values === null || values === void 0 ? void 0 : values.birthdayDate)
            : undefined;
        var profileDateOfBirth = (values === null || values === void 0 ? void 0 : values.birthdayDate)
            ? (_b = new Date(values === null || values === void 0 ? void 0 : values.birthdayDate)) === null || _b === void 0 ? void 0 : _b.toISOString()
            : undefined;
        var normalizedValues = (0, normalizeDepositValues_1.normalizeDepositValues)(values);
        changeDepositMethodIssue(false);
        makePayIn(__assign(__assign(__assign({ amount: String(amount), successUrl: depositCallbackUrls.success_url, cancelUrl: depositCallbackUrls.cancel_url, failUrl: depositCallbackUrls.fail_url, paymentMethod: selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.slug }, values), normalizedValues), { country: profileCountry, birthdayDate: depositDateOfBirth, phone: (values === null || values === void 0 ? void 0 : values.phone) ? "+".concat(values === null || values === void 0 ? void 0 : values.phone) : undefined, documentType: (values === null || values === void 0 ? void 0 : values.documentType)
                ? (_c = values === null || values === void 0 ? void 0 : values.documentType) === null || _c === void 0 ? void 0 : _c.value
                : undefined, lotteryId: (activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.id) && (activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.canParticipate)
                ? activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.id
                : undefined }));
        var updatedDataProfile = {
            firstName: values.firstName,
            lastName: values.lastName,
            city: values.city,
            dateOfBirth: profileDateOfBirth,
            postalCode: values.postalCode || values.zip,
            address: values.address,
            state: values === null || values === void 0 ? void 0 : values.state,
        };
        if (!isPhoneVerificationEnabled)
            updatedDataProfile['phone'] = values === null || values === void 0 ? void 0 : values.phone;
        updateProfile(updatedDataProfile);
    }, [
        updateProfile,
        activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.canParticipate,
        profileCountry,
        activeLottery === null || activeLottery === void 0 ? void 0 : activeLottery.id,
        checkDepositLimitReached,
        changeDepositMethodIssue,
        makePayIn,
        depositCallbackUrls,
        selectedMethod,
        isPhoneVerificationEnabled,
    ]);
    // const isFirstDeposit = useMemo(() => {
    //   return (
    //     !recentMethods.length &&
    //     bonusesData?.bonuses?.find(b =>
    //       b?.slug?.includes(BonusTag.WELCOME_DEPOSIT_FIRST),
    //     )
    //   )
    // }, [recentMethods.length, bonusesData])
    var setMethodSelected = (0, react_1.useCallback)(function (method) {
        // if (isFirstDeposit) {
        //   setIsOpenWelcomeBonus(true)
        // }
        setStep('topup');
        setSelectedMethod(method);
    }, [
    /*isFirstDeposit*/
    ]);
    var onBack = (0, react_1.useCallback)(function () {
        if (step === 'topup') {
            setStep('default');
            setSelectedMethod(null);
        }
        if (step === 'iframe') {
            setStep('topup');
        }
    }, [step]);
    (0, react_1.useEffect)(function () {
        setMounted(true);
        return function () { return setMounted(false); };
    }, []);
    // useEffect(() => {
    //   document?.getElementById('modal-container')?.scrollIntoView()
    // }, [step])
    (0, react_1.useEffect)(function () {
        if (!isLoading && !(methods === null || methods === void 0 ? void 0 : methods.length) && !isAuth && !!userDataError) {
            openSignIn("back=".concat(encodeURIComponent(window.location.href)));
        }
    }, [methods === null || methods === void 0 ? void 0 : methods.length, isAuth, isLoading, userDataError, openSignIn]);
    if (!methods || !mounted)
        return null;
    return (react_1.default.createElement("div", { id: "modal-container", className: "".concat(styles_module_scss_1.default.container, " ").concat(step === 'topup' || step === 'recent'
            ? styles_module_scss_1.default.additionalBottomMargin
            : '') },
        react_1.default.createElement(react_final_form_1.Form, { keepDirtyOnReinitialize: true, onSubmit: onSubmitHandler, initialValues: initialValues, validate: validationSchema && (0, apps_shared_1.formValidator)(validationSchema), render: function (_a) {
                var handleSubmit = _a.handleSubmit, values = _a.values, errors = _a.errors;
                return step !== 'iframe' ? (
                // Main flow logic for default/steps/topup/recent steps
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("form", { onSubmit: handleSubmit },
                        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.inner, " ").concat(isFailed ? styles_module_scss_1.default.innerFailed : '', " ").concat(isModal ? styles_module_scss_1.default.innerInModal : '', " ") },
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.bodyContent },
                                step !== 'recent' && (react_1.default.createElement(SubHeader_1.default, { method: selectedMethod, step: step, onBack: onBack, hasBackIcon: !oneDepositMethodOnly, oneDepositMethodOnly: oneDepositMethodOnly, currency: currentCurrency },
                                    react_1.default.createElement(Search_1.default, { onChange: onChangeSearch, value: search, onClean: function () {
                                            setSearch('');
                                        } }))),
                                step === 'recent' && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("div", { className: styles_module_scss_1.default.methodsRecentHeader },
                                        react_1.default.createElement("div", { className: styles_module_scss_1.default.methodsRecentTitle }, t('recentMethods')),
                                        react_1.default.createElement("div", { className: styles_module_scss_1.default.allPaymentMethods, onClick: function () {
                                                setStep('default');
                                                setSelectedMethod(null);
                                            } },
                                            react_1.default.createElement("span", null, t('allPaymentMethods')))),
                                    react_1.default.createElement("div", { className: styles_module_scss_1.default.methodsRecent }, recentMethods.map(function (el, idx) {
                                        var _a, _b, _c;
                                        return (react_1.default.createElement(Method_1.default, { key: "".concat(el.name).concat(idx), name: el.name || '', logo: (_a = el === null || el === void 0 ? void 0 : el.images) === null || _a === void 0 ? void 0 : _a.logo, slug: el.childMethodId || el.slug || '', 
                                            // @ts-ignore
                                            label: ((_b = el.styles) === null || _b === void 0 ? void 0 : _b.label) || '', 
                                            // @ts-ignore
                                            styles: el.styles, onClick: function () {
                                                setSelectedMethod(el);
                                            }, isActiveRecent: el.childMethodId
                                                ? (selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.childMethodId) ===
                                                    el.childMethodId
                                                : (selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.id) === el.id, isDisabled: false, background: (_c = paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings[el.name || '']) === null || _c === void 0 ? void 0 : _c.background }));
                                    })))),
                                step === 'default' &&
                                    !!(methodsWithSearch === null || methodsWithSearch === void 0 ? void 0 : methodsWithSearch.length) &&
                                    !search &&
                                    Object.keys(breakpoints).length > 0 &&
                                    !breakpoints.mobile && (react_1.default.createElement(Tabs_1.default, { methods: METHODS_FILTERS.filter(function (m) { return m.key === 'all' || categories.includes(m.key); }), method: filter, setMethod: setFilter })),
                                step === 'default' &&
                                    breakpoints.mobile &&
                                    (config === null || config === void 0 ? void 0 : config.supportBtnInHeader) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.supportButtonWrapperInHeader },
                                    react_1.default.createElement(ui_components_1.SupportButton, { text: t('needHelpQuestion') }))),
                                step === 'default' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.methodCategories },
                                    Boolean(methodsWithSearch.length) &&
                                        categories
                                            .filter(function (c) {
                                            return filter !== 'all'
                                                ? c === filter.toLowerCase()
                                                : !!(methodsWithSearch === null || methodsWithSearch === void 0 ? void 0 : methodsWithSearch.filter(function (m) { return m.category === (c === null || c === void 0 ? void 0 : c.toLowerCase()); }).length);
                                        })
                                            .map(function (c) {
                                            var category = METHODS_FILTERS.find(function (f) { return f.key === c; });
                                            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.categories, key: c },
                                                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.category, " ").concat(category ? styles_module_scss_1.default[category.key] : '', " ").concat((category === null || category === void 0 ? void 0 : category.stroke) ? styles_module_scss_1.default.stroke : '') },
                                                    react_1.default.createElement("div", null,
                                                        category && react_1.default.createElement(category.Icon, null),
                                                        react_1.default.createElement("span", { className: styles_module_scss_1.default.customIcon }), category === null || category === void 0 ? void 0 :
                                                        category.label)),
                                                react_1.default.createElement("div", { className: styles_module_scss_1.default.methods }, methodsWithSearch === null || methodsWithSearch === void 0 ? void 0 : methodsWithSearch.filter(function (m) { return m.category === (c === null || c === void 0 ? void 0 : c.toLowerCase()); }).map(function (el, idx) {
                                                    var _a, _b, _c;
                                                    return (react_1.default.createElement(Method_1.default, { key: "".concat(el.name).concat(idx), name: el.name || '', logo: (_a = el === null || el === void 0 ? void 0 : el.images) === null || _a === void 0 ? void 0 : _a.logo, slug: el.childMethodId || el.slug || '', 
                                                        // @ts-ignore
                                                        label: ((_b = el.styles) === null || _b === void 0 ? void 0 : _b.label) || '', 
                                                        // @ts-ignore
                                                        styles: el.styles, onClick: function () {
                                                            setMethodSelected(el);
                                                        }, isActive: (selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.name) === el.name, isDisabled: false, background: (_c = paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings[el.name || '']) === null || _c === void 0 ? void 0 : _c.background }));
                                                }))));
                                        }),
                                    !(methodsWithSearch === null || methodsWithSearch === void 0 ? void 0 : methodsWithSearch.length) && search && (react_1.default.createElement("div", { className: styles_module_scss_1.default.searchIsEmpty }, t('noResultsFound', { search: search }))),
                                    isLoading && (react_1.default.createElement("div", { className: styles_module_scss_1.default.searchIsEmpty },
                                        react_1.default.createElement(ui_components_1.LoadingSpinner, null))),
                                    !(methods === null || methods === void 0 ? void 0 : methods.length) && !isLoading && (react_1.default.createElement("div", { className: styles_module_scss_1.default.searchIsEmpty }, t('noMethodsAvailable'))))),
                                (step === 'topup' || step === 'recent') && (react_1.default.createElement(DepositFields_1.DepositFields, { step: step, handleClickSubmitBtn: handleClickSubmitBtn, min: currencySettings.min, max: currencySettings.max, bonusesData: bonusesData, isLoading: isLoadingBonuses, isValidating: isValidatingBonuses, fixedTransaction: currencySettings.fixedTransaction, currentCurrency: balanceData === null || balanceData === void 0 ? void 0 : balanceData.currency, selectedMethod: selectedMethod, initialValues: initialValues, values: values, promocode: promocode, isSubmitting: isSubmitting, setPromocode: setPromocode }))),
                            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.bottomContent, " ").concat(isModal ? styles_module_scss_1.default.bottomContentInModal : '', " ").concat(isFailed ? styles_module_scss_1.default.failed : '') }, (step === 'topup' || step === 'recent') && (react_1.default.createElement(ProcessingTotalInfo_1.default, { fee: 0, methodMetadata: selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.metadata, totalAmount: values.amount, currency: currentCurrency, bonusesData: bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.bonuses }, function (_a) {
                                var minDepositAmount = _a.minDepositAmount, isSubmitButtonDisabled = _a.isSubmitButtonDisabled, isRequiredFieldsEmpty = _a.isRequiredFieldsEmpty;
                                return (react_1.default.createElement(TopupButton_1.default, { minDepositAmount: minDepositAmount, currency: currentCurrency, amount: values.amount, handleClickSubmitBtn: handleClickSubmitBtn, isSubmitting: isSubmitting, isSubmitButtonDisabled: isSubmitButtonDisabled, isRequiredFieldsEmpty: isRequiredFieldsEmpty }));
                            }))))))) : (
                // Flow for iframe step
                react_1.default.createElement("div", { className: styles_module_scss_1.default.iframeWrapper },
                    react_1.default.createElement(SubHeader_1.default, { method: selectedMethod, step: step, onBack: onBack, hasBackIcon: true, oneDepositMethodOnly: oneDepositMethodOnly, currency: currentCurrency }, null),
                    !IFrameUrl && (react_1.default.createElement(ProcessingTotalInfo_1.default, { fee: 0, methodMetadata: selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.metadata, totalAmount: values.amount, currency: currentCurrency, bonusesData: bonusesData === null || bonusesData === void 0 ? void 0 : bonusesData.bonuses }, null)),
                    (selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.category) === 'crypto' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.requires },
                        react_1.default.createElement("img", { src: "/img/icons/warning.svg", alt: "warning" }),
                        react_1.default.createElement("span", null, t('methodIframeCrypto')))),
                    (selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.category) === 'vouchers' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.requires },
                        react_1.default.createElement("img", { src: "/img/icons/warning.svg", alt: "warning" }),
                        react_1.default.createElement("span", null, t('methodIframeVoucher')))),
                    react_1.default.createElement("iframe", { width: "100%", height: "100%", src: IFrameUrl })));
            } }),
        isChangeDepositMethodIssue && isDepositMethodIssuePopupEnabled && (react_1.default.createElement(DepositMethodIssue_1.DepositMethodIssue, { onClose: function () { return changeDepositMethodIssue(false); } }))));
};
exports.default = Deposit;
